import { AggregationTableRow } from "@ext/markdown/elements/table/edit/components/Helpers/AggregationTableRow";
import type { RefObject } from "react";

export const TableFooter = ({ tableRef }: { tableRef: RefObject<HTMLTableElement> }) => {
	return (
		<tfoot>
			<AggregationTableRow tableRef={tableRef} />
		</tfoot>
	);
};
